import { useQuery } from '@tanstack/react-query';
import { pb } from '@/core/api';

export type Tier = {
  min: number;
  max: number | null;
  price_per_lead: number;
};

type PricingTable = { id: string; tiers: Tier[]; is_active: boolean };

export function useActivePricing() {
  return useQuery({
    queryKey: ['pricing-active'],
    queryFn: async (): Promise<PricingTable> =>
      pb.send('/api/pricing/active', { method: 'GET' }),
    staleTime: 60_000,
  });
}
